<template>
<div class="chapter">
<div class="inner_page">
<div id="dedication">
<div class="generated-style">
<p class="x2fm-ttl" xml:lang="en-us"><a href="#/Contents#dedication">Dedication</a></p>
<p class="x2ded-only" xml:lang="en-us"><em class="italic">To Jane Austen and all those who love her</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?3ef28544